import {
    FormStyle,
    getLocaleDayNames,
    getLocaleMonthNames,
    getLocaleNumberSymbol,
    NumberSymbol,
    TranslationWidth
} from '@angular/common'
import { CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { ChartModule } from 'angular2-highcharts'
import { HighchartsStatic } from 'angular2-highcharts/dist/HighchartsService'
import * as Highcharts from 'highcharts'
import * as HighchartsNoDataToDisplay from 'highcharts/modules/no-data-to-display'
import { AppCommonModule } from '../common/common.module'
import { AppCoreModule } from '../core/core.module'
import { DashboardExtratosComponent } from './dashboard-extratos/dashboard-extratos.component'
import { Ultimos10DiasComponent } from './dashboard-extratos/ultimos-10-dias/ultimos-10-dias.component'
import { VendasRecebimentosComponent } from './dashboard-extratos/vendas-recebimentos/vendas-recebimentos.component'
import { ExportacaoMovimentoComponent } from './exportacao-movimento/exportacao-movimento.component'
import { ExportacaoService } from './exportacao-movimento/shared/exportacao.service'
// tslint:disable-next-line:max-line-length
import { DetalheExtratoDeAntecipacoesComponent } from './extratos-de-antecipacoes/detalhe-extrato-de-antecipacoes/detalhe-extrato-de-antecipacoes.component'
import { ExtratosDeAntecipacoesComponent } from './extratos-de-antecipacoes/extratos-de-antecipacoes.component'
import { ExtratoDeAntecipacoesService } from './extratos-de-antecipacoes/shared/extrato-de-antecipacoes.service'
// tslint:disable-next-line:max-line-length
import { DetalheExtratoDeRecebimentosComponent } from './extratos-de-recebimentos/detalhe-extrato-de-recebimentos/detalhe-extrato-de-recebimentos.component'
import { ExtratosDeRecebimentosComponent } from './extratos-de-recebimentos/extratos-de-recebimentos.component'
import { ExtratoDeRecebimentosService } from './extratos-de-recebimentos/shared/extrato-de-recebimentos.service'
import { DetalheExtratoDeVendasComponent } from './extratos-de-vendas/detalhe-extrato-de-vendas/detalhe-extrato-de-vendas.component'
import { EstabelecimentosPendentesComponent } from './estabelecimentos-pendentes/estabelecimentos-pendentes.component'
import { ExtratosDeVendasComponent } from './extratos-de-vendas/extratos-de-vendas.component'
import { ExtratoDeVendasService } from './extratos-de-vendas/shared/extrato-de-vendas.service'
import { ExtratosComponent } from './extratos.component'
import { FiltroExtratosFormComponent } from './filtro-extratos-form/filtro-extratos-form.component'
import { DadosRelatorioService } from './relatorio/dados-relatorio.service'
import { GerarRelatorioModalComponent } from './relatorio/gerar-relatorio-modal/gerar-relatorio-modal.component'
import { RelatorioDetalhadoComponent } from './relatorio/relatorio-detalhado/relatorio-detalhado.component'
import { RelatorioResumidoComponent } from './relatorio/relatorio-resumido/relatorio-resumido.component'
import { RelatorioComponent } from './relatorio/relatorio.component'
import { RelatorioService } from './relatorio/relatorio.service'
import { buttonExportacaoMovimentoDirective } from './exportacao-movimento/exportacao-movimento.directive';
import { DetalheEstabelecimentosComponent } from './extratos-de-vendas/detalhe-estabelecimentos/detalhe-estabelecimentos.component';
import { DetalheRecebimentosEstabelecimentosComponent } from './extratos-de-recebimentos/detalhe-recebimentos-estabelecimentos/detalhe-recebimentos-estabelecimentos.component';
import { DetalheAntecipacoesEstabelecimentoComponent } from './extratos-de-antecipacoes/detalhe-antecipacoes-estabelecimento/detalhe-antecipacoes-estabelecimento.component'


@NgModule({
    imports: [AppCommonModule, AppCoreModule, RouterModule, ChartModule],
    declarations: [
        ExtratosComponent,
        FiltroExtratosFormComponent,
        EstabelecimentosPendentesComponent,
        DetalheExtratoDeVendasComponent,
        DetalheExtratoDeRecebimentosComponent,
        DetalheExtratoDeAntecipacoesComponent,
        ExtratosDeVendasComponent,
        ExtratosDeRecebimentosComponent,
        ExtratosDeAntecipacoesComponent,
        DashboardExtratosComponent,
        VendasRecebimentosComponent,
        Ultimos10DiasComponent,
        ExportacaoMovimentoComponent,
        RelatorioComponent,
        GerarRelatorioModalComponent,
        RelatorioResumidoComponent,
        RelatorioDetalhadoComponent,
        buttonExportacaoMovimentoDirective,
        DetalheEstabelecimentosComponent,
        DetalheRecebimentosEstabelecimentosComponent,
        DetalheAntecipacoesEstabelecimentoComponent
    ],
    providers: [
        ExtratoDeRecebimentosService,
        ExtratoDeAntecipacoesService,
        ExtratoDeVendasService,
        ExportacaoService,
        RelatorioService,
        DadosRelatorioService,
        {
            provide: HighchartsStatic,
            useFactory: highchartsFactory,
            deps: [LOCALE_ID]
        }
    ],
    entryComponents: [GerarRelatorioModalComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ExtratosModule { }

export function highchartsFactory(locale: string) {
    HighchartsNoDataToDisplay(Highcharts)

    Highcharts.setOptions({
        lang: {
            months: getLocaleMonthNames(
                locale,
                FormStyle.Standalone,
                TranslationWidth.Wide
            ),
            shortMonths: getLocaleMonthNames(
                locale,
                FormStyle.Standalone,
                TranslationWidth.Abbreviated
            ),
            weekdays: getLocaleDayNames(
                locale,
                FormStyle.Standalone,
                TranslationWidth.Wide
            ),
            decimalPoint: getLocaleNumberSymbol(locale, NumberSymbol.Decimal),
            thousandsSep: getLocaleNumberSymbol(locale, NumberSymbol.Group),
            noData: '<strong class="lead" style="color: #333333">Não há dados</strong>'
        }
    })

    return Highcharts
}



// WEBPACK FOOTER //
// ./src/app/extratos/extratos.module.ts